import { Box } from '@chakra-ui/react';

const Loading = () => {
  return <Box>Loading</Box>;
};

export default Loading;
